'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import HydrationGatedButton from '@/common/HydrationGatedButton';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';

export default function AddCoSignerButton() {
  const { setAddCoApplicantModalOpen } = useModalContext();
  const { trackEvent } = useContext(AnalyticsContext);

  const handleAddCosigner = () => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.CLICKS_ADD_COSIGNER_HERO);
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_ADD_COSIGNER_HERO);
    setAddCoApplicantModalOpen(true);
  };

  return (
    <HydrationGatedButton
      data-analytics-id="Financing Add A Co-Signer Button"
      variant="tertiary"
      onClick={handleAddCosigner}
      data-testid="add-co-signer"
    >
      Add a Co-signer
    </HydrationGatedButton>
  );
}
